import { render, staticRenderFns } from "./sales-invoices-table.vue?vue&type=template&id=687a1680"
import script from "./sales-invoices-table.vue?vue&type=script&lang=js"
export * from "./sales-invoices-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports